'use client';

import { Analytics, inquiryKakao } from 'Shared/utils/client';
import { LINK, SIZE } from '@constants';
import { Box, FloatingKakao, useTheme } from '@viewup/ui';
import { usePathname } from 'next/navigation';

const buttonVisibleLocations: string[] = [LINK.HOME, LINK.VIEWING];

export const KakaoFloating = () => {
  const pathname = usePathname();
  const theme = useTheme();

  if (!buttonVisibleLocations.includes(pathname)) return null;

  return (
    <Box
      bottom={0}
      maxWidth={440}
      position='fixed'
      width='100%'
      zIndex={theme.zIndex.popover[1051]}
    >
      <Box
        onClick={() => {
          Analytics.getInstance().track('KAKAO_INQUIRY', { page: pathname });
          inquiryKakao();
        }}
        position='absolute'
        style={{
          bottom: `calc(${SIZE.BOTTOM_BAR_HEIGHT + 4}px + env(safe-area-inset-bottom))`,
          cursor: 'pointer',
          right: 4,
        }}
        width='max-content'
        zIndex={theme.zIndex.fixed[1000]}
      >
        <FloatingKakao />
      </Box>
    </Box>
  );
};
